import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import {
  AppBar,
  Avatar,
  Box,
  Divider,
  Hidden,
  IconButton,
  Toolbar
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
// import { RootState } from '../../redux/reducers/rootReducer';
import { useSelector } from 'react-redux';
import Logo from '../../components/Logo';
import { RootState } from '../../redux/reducers/rootReducer';

interface Props {
  className?: string;
  onMobileNavOpen?: () => void;
}
function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#E85D04';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name: string) {
  return {
    sx: {
      bgcolor: stringToColor(name)
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
  };
}

function TopBar({ className, onMobileNavOpen, ...rest }: Props) {
  const { user } = useSelector((store: RootState) => store.user);

  return (
    <AppBar
      elevation={1}
      {...rest}
      sx={{ backgroundColor: '#E85D04', position: 'fixed', zIndex: 1 }}
    >
      <Toolbar>
        <RouterLink to="/app/dashboard">
          <Logo />
        </RouterLink>
        <Box style={{ marginLeft: 'auto', flex: 1 }}>
          <Avatar
            component={RouterLink}
            // src={user.avatar}
            to="/app/account"
            style={{
              marginLeft: 'auto',
              flex: 1,
              cursor: 'pointer',
              width: 50,
              height: 50,
              backgroundColor: '#9D0208'
            }}
            {...stringAvatar(`${user?.firstName} ${user?.lastName}`)}
          />
        </Box>
        <Hidden lgUp>
          <div style={{ marginLeft: '0 auto', gap: '0 auto' }}>
            <IconButton
              color="inherit"
              onClick={onMobileNavOpen}
              sx={{ color: '#fff' }}
            >
              <MenuIcon />
            </IconButton>
          </div>
        </Hidden>
      </Toolbar>
      <Divider variant="fullWidth" sx={{ backgroundColor: '#E85D04' }} />
    </AppBar>
  );
}

export default TopBar;
